import { FC } from 'react';
import { navigate } from 'vike/client/router';

interface NavBarProps {
    theme: "light" | "dark"
}

const NavBar: FC<NavBarProps> = ({ theme }) => {

    const handleGetStarted = () => {
        navigate("/home");
    }

    return (
        <div className="w-full px-4 md:px-10 py-4 absolute top-0 flex justify-between items-center z-50">
            <p className={`font-inter font-extrabold text-[24px] !leading-[100%] align-middle ${theme === "light" ? "text-black" : "text-white"}`}>curo.</p>
            <button className={`font-figtree font-normal text-base align-middle py-2 px-4 rounded-[8px] border-2 border-white ${theme === "dark" ? "bg-gradient-to-b from-white to-[#CECECE] text-black900" : "bg-[#222222] text-white"}`} onClick={handleGetStarted}>
                Get Started
            </button>
        </div>
    )
}
export default NavBar;